<template>
  <div class="g-container g-container-bg">
    <!--详情头部-->
    <div class="com-detail-hd">
      <div class="com-hd-inner"
           :style="{backgroundImage:`url(${backgroundImage})`}">
        <div class="com-hd-info">
          <div class="com-hd-face">
            <img :src="detail.proImage"
                 alt />
          </div>
          <div class="com-hd-name">
            <div class="hd-bottom-td">
              <div class="hd-name-row">{{detail.title}}</div>
              <!--今日信息-->
              <div class="hd-name-row">
                <span>{{timeAgo}}</span>
                <span></span>
                <span>天气：{{weather}}</span>
              </div>
            </div>
          </div>
        </div>
        <!--右侧操作-->
        <div class="com-hd-handle">
          <div class="hd-bottom-td">
            <span class="cm-sign-btn"
                  @click="openQiandao">签到详情</span>
            <h-qrcode></h-qrcode>
          </div>
        </div>
      </div>
    </div>
    <div class="m-container m-width">
      <!--面包屑-->
      <div class="crumbs-box">
        <router-link tag="a"
                     class="c-crumbs"
                     :to="{name:'default'}">首页</router-link>
        <span class="c-sep">&gt;</span>
        <span class="c-current">匠心记</span>
        <span class="c-sep">&gt;</span>
        <span class="c-current">{{detail.title}}</span>
      </div>
      <!--主体-->

      <!-- 主体 -->
      <div class="daily-content-p m-structure-content">
        <!-- 右侧功能栏 -->
        <div class="m-structure-quick">
          <div class="structure-btn"
               @click="gotoCreate">发布内容</div>
          <div class="structure-box"
               v-if="detail.postUser">
            <div class="com-md-face">
              <img :src="detail.postUser.headImage"
                   alt />
            </div>
            <div class="str-row">
              <span class="str-label">{{detail.postUser.type}}</span>
              <i class="star-icon"
                 :class="detail.postUser.starClass"></i>
            </div>
            <div class="str-row">
              <span class="str-name">{{detail.postUser.nickName}}</span>
              <span class="str-tag-icon">{{detail.postUser.tags[0]}}</span>
            </div>
          </div>
          <div class="scan-code-quick">
            <div class="code-quick-pic">
              <qrcode-vue :value="localHref"
                          :size="170"
                          level="H"></qrcode-vue>
            </div>
          </div>
          <d-qiandao v-if="qiandaoDir"
                     @close="closeQiandao"></d-qiandao>

        </div>
        <div class="detail-main-p">
          <div class="cover-p">
            <div class="cover-head-p">
              <h3>{{detail.title}}</h3>
              <div class="head-other-p">
                <div class="date-p">
                  <span>发布时间：{{detail.createdTime ? detail.createdTime.slice(0,-9) : ''}}</span>
                </div>
                <div class="weather-p">
                  <span>天气：</span>
                  <img :src="weatherIcon"
                       alt />
                </div>
                <div class="icon-box-p">
                  <div class="hits-icon-p">
                    <div></div>
                    <span>{{detail.hits}}</span>
                  </div>
                  <div class="rep-icon-p">
                    <div></div>
                    <span>{{detail.repNum}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 基础检查 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%">
              <view-qe-upload-file class="create-cover-p"
                                   ref="cover"
                                   :basePicArr="picDataArr"
                                   :baseFileType="baseFileType"
                                   :oldExtraFile="extraFile"
                                   style="border: none;padding: 0px;">
                <span slot="title">基础检查</span>
                <span slot="remark">《现场基础情况检查告知函》</span>
              </view-qe-upload-file>
            </div>
            <!-- 现场标样制作 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%"
                 v-show="getSceneStandardMakeShow">
              <view-scene-standard-make class="material-edit-p"
                                        ref="scene"
                                        :oldSceneStandardMakeDataArr="sceneStandardMakeArr"
                                        style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;">
                <span slot="title">现场标样制作</span>
              </view-scene-standard-make>
            </div>
            <!-- 原材料进场 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%"
                 v-show="getRawMaterialEnterShow">
              <view-raw-material-enter class="quality-edit-p"
                                       ref="quality"
                                       :oldRowPicDataArr="rowPicDataArr"
                                       :oldRowCheckPicDataArr="rowCheckPicDataArr"
                                       :oldRowCheckFile="rowCheckFile"
                                       :rawCheckFlag="getRawMaterialCheckShow"
                                       style="padding: 0px 20px 0px 0px;">
                <span slot="title">原材料进场</span>
                <template slot="radioInfo">
                  <template>
                    <el-radio-group v-model="rowRadioValue"
                                    text-color="#626aef"
                                    size="small"
                                    fill="rgb(239, 240, 253)"
                                    style="margin-bottom:1%;margin-top: 0.5%;">
                      <el-radio border
                                disabled
                                :label=1>良好</el-radio>
                      <el-radio border
                                disabled
                                :label=2>预警</el-radio>
                      <el-radio border
                                disabled
                                :label=3>异常</el-radio>
                    </el-radio-group>
                  </template>
                  <div class="create-title-p"
                       style="margin: 0px;padding-bottom: 10px;">
                    <input type="text"
                           placeholder="描述"
                           v-model="rowRadioRemark"
                           disabled />
                  </div>
                </template>
                <template slot="checkInfo">
                  <div class="create-title-p">
                    <input type="text"
                           v-model="checkInstitutionName"
                           disabled />
                  </div>
                  <div class="create-title-p">
                    <input type="text"
                           v-model="checkResult"
                           disabled />
                  </div>
                </template>
              </view-raw-material-enter>
            </div>
            <!-- 施工过程管控 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%"
                 v-show="getConControlNodeShow">
              <view-con-control-node class="material-edit-p"
                                     ref="material"
                                     :oldConControlDataArr="constructionControlDataArr"
                                     style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;">
                <span slot="title">施工过程管控</span>
              </view-con-control-node>
            </div>
            <!-- 避免气候、交叉施工等外部因素影响 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%"
                 v-show="getExtrinsicFactorsShow">
              <view-extrinsic-factors-node class="material-edit-p"
                                           ref="extrinsic"
                                           :oldExtrinsicFactorsDataArr="extrinsicFactorsArr"
                                           style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;">
                <span slot="title">避免气候、交叉施工等外部因素影响</span>
              </view-extrinsic-factors-node>
            </div>
            <!-- 成品抽检 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%"
                 v-show="getProSpotCheckShow">
              <view-product-spot-check class="material-edit-p"
                                       ref="spot"
                                       :oldProCheckPicDataArr="proCheckPicDataArr"
                                       :oldProCheckFile="proCheckFile"
                                       style="padding-top: 0px;padding-bottom: 20px;">
                <span slot="title">成品抽检</span>
                <template slot="checkInfo">
                  <div class="create-title-p">
                    <input type="text"
                           disabled
                           v-model="proCheckInstitutionName" />
                  </div>
                  <div class="create-title-p">
                    <input type="text"
                           disabled
                           v-model="proCheckResult" />
                  </div>
                </template>
              </view-product-spot-check>
            </div>
            <!-- 信息反馈 -->
            <div class="carate-qe-main-p"
                 style="margin-bottom: 30px;width:98%"
                 v-show="getInfoFeedbackShow">
              <view-info-feedback class="material-edit-p"
                                  ref="info"
                                  :oldInfoFbPicArr="infoFeedbackPicArr"
                                  :infoFileType="infoFileType"
                                  :oldInfoFbFile="oldInfoFbFile"
                                  style="padding-top: 0px;padding-bottom: 20px;">
                <span slot="title">信息反馈</span>
                <span slot="remark">《现场品控工程师信息反馈表》</span>
              </view-info-feedback>
            </div>
            <!-- 评论列表 -->
            <div class="structure-border comment-p"
                 id="toCommentBox"
                 ref="comment">
              <to-comment @jxjAddReplis="jxjAddReplis"
                          :headImage="detail.postUser && detail.postUser.headImage"></to-comment>
              <comment-box :commentList="detail.reps"
                           :replyBtnDir="true"
                           @showReplayFunc="showReplayFunc">
                <template scope="props">
                  <reply-comment :replyId="props.rowdata.id"
                                 @jxjAddReplis="jxjAddReplis"></reply-comment>
                </template>
              </comment-box>
            </div>

            <view-aside-right @scrollToCover="scrollToCover"
                              @scrollToScene="scrollToScene"
                              @scrollToQuality="scrollToQuality"
                              @scrollToMaterial="scrollToMaterial"
                              @scrollToExtrinsic="scrollToExtrinsic"
                              @scrollToSpot="scrollToSpot"
                              @scrollToInfo="scrollToInfo"
                              @scrollToCommentcss="scrollToCommentcss"
                              :isLike="isLike"
                              @scrollToTop="scrollToTop"
                              style="margin-left: 629px;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../html/components/crumbs/crumbs.scss';
import '../../../../html/components/detailHd/detailHd.scss';
import '../../../../html/components/tabs/tabs.scss';

import '../../../../html/components/structure/structure.scss';
import '../../../../html/components/enterprise/enterprise.scss';
import '../../../../html/components/picture/picture.scss';
import '../../../../html/components/comments/comments.scss';

import '../../../../html/pages/originality/daily/daily.scss';
import '../../../../html/pages/originality/qe/qe.scss';

import '../../../../html/components/fixBar/fixBar.scss';
import "../../../../html/pages/originality/createQe/testQE.scss"

import toTop from '../../../../components/to-top/to-top.vue';
import dQiandao from '../detail/components/d-qiandao.vue';
import commentBox from '../../../../components/comment-box/comment-box.vue';
import replyComment from '../../../../components/comment-box/reply-comment.vue';
import toComment from '../../../../components/to-comment/to-comment.vue';

import ImageUpload from "../../../../components/imageUpload/ImageUpload"

import { getJxjPostDetail, jxjAddReplis, getWeather, jxjGetProQEReport } from "../../../../api/index"
import stars from '../../../../pubilc/util/stars';
import timeago from '../../../../pubilc/util/timeago';
import HQrcode from '../../../../components/h-qrcode/h-qrcode.vue';
import QrcodeVue from 'qrcode.vue';
import ViewAsideRight from './components/viewAsideRight.vue';
import ViewQeUploadFile from './components/viewQeUploadFile.vue';
import ViewRawMaterialEnter from './components/viewRawMaterialEnter.vue';
import ViewConControlNode from './components/viewConControlNode.vue';
import ViewExtrinsicFactorsNode from './components/viewExtrinsicFactorsNode.vue';
import ViewProductSpotCheck from './components/viewProductSpotCheck.vue';
import ViewInfoFeedback from './components/viewInfoFeedback.vue';
import ViewSceneStandardMake from './components/viewSceneStandardMake.vue';

export default {
  name: 'newViewQE',
  data () {
    return {
      id: "",
      qeId: "",
      oldData: {},
      params: {//总参
        ForumsId: "",
        Name: "",
        Content1: [],
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      },
      sceneStandardMakeNode: {
        nodeName: "现场标样制作",
        subnodelist: []
      },
      sceneStandardMakeArr: [],
      sceneStandardMakeNodeCount: 2,// 现场标样制作，当前模板写死，选项节点数量固定
      constructionControlData: {
        nodeName: "施工过程管控",
        subnodelist: []
      },
      constructionControlDataArr: [],
      conControlNodeCount: 18,// 施工过程管控，当前模板写死，选项节点数量固定
      extrinsicFactorsData: {
        nodeName: "避免气候、交叉施工等外部因素影响",
        subnodelist: []
      },
      extrinsicFactorsArr: [],
      extrinsicFactorsNodeCount: 4,// 外部因素，当前模板写死，选项节点数量固定
      title: "",
      checkInstitutionName: "",//原材料进场 检检测机构名称
      checkResult: "",// 原材料进场 检测结果描述
      picDataArr: [],//基础检查 原图
      extraData: {//基础检查 文件
        type: 'file',
        file: ''
      },
      extraFile: "",//基础检查 回显文件
      baseFileType: "",//基础检查 文件类型
      rowRadioValue: 0,//原材料储存 品质
      rowRadioRemark: '',//原材料储存 描述
      rowPicDataArr: [],//原材料储存 原图
      rowCheckPicDataArr: [],//原材料抽检 原图
      rowCheckFileData: {//原材料抽检 文件
        type: 'file',
        file: ''
      },
      rowCheckFile: "",//原材料抽检 回显文件
      proCheckInstitutionName: "",//成品抽检 检检测机构名称
      proCheckResult: "",//成品抽检 检测结果描述
      proCheckPicDataArr: [],//成品抽检原图
      proCheckFileData: {//成品抽检文件
        type: 'file',
        file: ''
      },
      proCheckFile: "",//成品抽检 回显文件
      infoFeedbackPicArr: [],//信息反馈 图片
      infoFeedbackFileData: {//信息反馈 文件
        type: '',
        file: ''
      },
      infoFileType: "",//信息反馈 文件类型
      oldInfoFbFile: "",//信息反馈 文件回显
      //view字段
      detail: {},
      backgroundImage: '',
      weather: '',
      weatherIcon: '',
      timeAgo: '',
      qiandaoDir: false,
      reParams: {
        id: "",
        repId: '',
        content: '',
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      },
      sunnyImage: './gif/sunny.gif',
      hotImage: './gif/hot.gif',
      rainImage: './gif/rain.gif',
      snowImage: './gif/snow.gif',
      cloudyImage: './gif/cloudy.gif',
      fogImage: './gif/fog.gif',
      sunnyIcon: require('../../../../html/pages/originality/qe/images/sunny.png'),
      hotIcon: require('../../../../html/pages/originality/qe/images/hot.png'),
      rainIcon: require('../../../../html/pages/originality/qe/images/rain.png'),
      snowIcon: require('../../../../html/pages/originality/qe/images/snow.png'),
      cloudyIcon: require('../../../../html/pages/originality/qe/images/cloudy.png'),
      fogIcon: require('../../../../html/pages/originality/qe/images/fog.png'),
      localHref: location.href,
      isLike: false,
    }
  },
  computed: {
    getSceneStandardMakeShow () {//现场标样制作
      let ssmnFlag = true
      if (this.sceneStandardMakeNode.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.sceneStandardMakeNode.subnodelist) {
          if (subnode.nodeState < 1 && subnode.remark.length < 1 && subnode.picArr.length < 1) {
            subnodeCount = subnodeCount + 1
          }
        }
        if (subnodeCount === this.extrinsicFactorsNodeCount) {
          ssmnFlag = false
        }
      } else {
        ssmnFlag = false
      }
      return ssmnFlag
    },
    getRawMaterialEnterShow () {//原材料进场
      let rawFlag = true
      if (this.rowRadioValue < 1 && this.rowPicDataArr.length < 1 && this.rowCheckPicDataArr.length < 1 &&
        this.checkInstitutionName.length < 1 && this.checkResult.length < 1 && this.rowCheckFile.length < 1) {
        rawFlag = false
      }
      return this.title.length > 0 && rawFlag
    },
    getRawMaterialCheckShow () {//原材料抽检
      if (this.rowCheckPicDataArr.length > 0 && this.checkInstitutionName.length > 0 && this.checkResult.length > 0) {
        return true
      }
      return false
    },
    getConControlNodeShow () {//施工过程管控
      let conFlag = true
      if (this.constructionControlData.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.constructionControlData.subnodelist) {
          if (subnode.subnodelist.length > 0) {
            for (let grandsonNode of subnode.subnodelist) {
              if (grandsonNode.nodeState < 1) {
                subnodeCount = subnodeCount + 1
              }
            }
          } else {
            conFlag = false
          }
        }
        if (subnodeCount === this.conControlNodeCount) {
          conFlag = false
        }
      } else {
        conFlag = false
      }
      return conFlag
    },
    getExtrinsicFactorsShow () {//外部因素
      let efFlag = true
      if (this.extrinsicFactorsData.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.extrinsicFactorsData.subnodelist) {
          if (subnode.nodeState < 1) {
            subnodeCount = subnodeCount + 1
          }
        }
        if (subnodeCount === this.extrinsicFactorsNodeCount) {
          efFlag = false
        }
      } else {
        efFlag = false
      }
      return efFlag
    },
    getProSpotCheckShow () {//成品抽检
      let spotFlag = true
      if (this.proCheckPicDataArr.length < 1 && this.proCheckInstitutionName.length < 1 && this.proCheckResult.length < 1 &&
        this.proCheckFile.length < 1) {
        spotFlag = false
      }
      return spotFlag
    },
    getInfoFeedbackShow () {//信息反馈
      console.log("getInfoFeedbackShow", this.infoFeedbackPicArr)
      console.log("getInfoFeedbackShow", this.oldInfoFbFile)
      return this.infoFeedbackPicArr.length > 0 || this.oldInfoFbFile.length > 0
    }
  },
  components: {
    ImageUpload,
    commentBox,
    replyComment,
    toComment,
    toTop,
    dQiandao,
    HQrcode,
    QrcodeVue,
    ViewAsideRight,
    ViewQeUploadFile,
    ViewRawMaterialEnter,
    ViewConControlNode,
    ViewExtrinsicFactorsNode,
    ViewProductSpotCheck,
    ViewInfoFeedback,
    ViewSceneStandardMake,
  },
  methods: {
    async init () {
      let res = await getJxjPostDetail({
        id: this.qeId
      })
      if (res.Type == "Success") {
        this.timeAgo = timeago(new Date(res.Data.createdTime));
        if (res.Data.postUser) {
          res.Data.postUser.starClass = stars(res.Data.postUser.star);
        }
        res.Data.reps.forEach(item => {
          item.showReplay = false;
        })
        this.detail = res.Data;
        if (res.Data.postData.length > 0) {
          let content = res.Data.postData[0].content
          if (content.length) {
            this.oldData = JSON.parse(content)
            // 标题
            this.title = res.Data.title
            for (let node of this.oldData) {
              // 基础检查
              if ("基础检查" == node.nodeName) {
                if (node.img && node.img.length > 0) {
                  //判断是PDF还是图片
                  let fileType = node.img[0].split('.').pop().toLowerCase()
                  if ("pdf" == fileType) {
                    this.baseFileType = "PDF"
                    this.extraData.file = node.img[0]
                    this.extraFile = node.img[0]
                  } else {
                    this.baseFileType = "IMG"
                    this.picDataArr = node.img
                  }
                }
              }
              // 现场标样制作 
              if ("现场标样制作" == node.nodeName) {
                this.sceneStandardMakeNode.subnodelist = node.subnodelist
                this.sceneStandardMakeArr = node.subnodelist
              }
              // 原材料进场
              if ("原材料进场" == node.nodeName) {
                this.setRawEnterData(node)
              }
              // 施工过程管控
              if ("施工过程管控" == node.nodeName) {
                this.constructionControlData.subnodelist = node.subnodelist
                //console.log("施工过程管控", node.subnodelist)
                this.constructionControlDataArr = node.subnodelist
              }
              // 避免气候、交叉施工等外部因素影响 
              if ("避免气候、交叉施工等外部因素影响" == node.nodeName) {
                this.extrinsicFactorsData.subnodelist = node.subnodelist
                this.extrinsicFactorsArr = node.subnodelist
              }
              // 成品抽检
              if ("成品抽检" == node.nodeName) {
                //console.log("成品抽检", node)
                this.proCheckInstitutionName = node.checkInstitutionName
                this.proCheckResult = node.checkResult
                this.proCheckPicDataArr = node.img
                this.proCheckFileData.file = node.file
                this.proCheckFile = node.file
                // "nodeName": "成品抽检",
                // "img": [
                //     "https://www.iduilv.com/Upload/OOS/e16df6e3e15b49aea32e212b223f173e.png"
                // ],
                // "checkInstitutionName": "测试机构2",
                // "checkResult": "良好",
                // "file": "/Upload/OOS/36f8e89be5cc4229938d7d73f3842ab7.pdf"
              }
              // 信息反馈
              if ("信息反馈" == node.nodeName) {
                //判断是PDF还是图片
                if (node.img && node.img.length > 0) {
                  let fileType = node.img[0].split('.').pop().toLowerCase()
                  if ("pdf" == fileType) {
                    this.infoFileType = "PDF"
                    this.infoFeedbackFileData.file = node.img[0]
                    this.oldInfoFbFile = node.img[0]
                  } else {
                    this.infoFileType = "IMG"
                    //console.log("信息反馈", node.img)
                    if (node.img && node.img[0] && node.img[0].length > 0) {
                      this.infoFeedbackPicArr = node.img
                    }
                  }
                }
              }
            }
          }
        }
      } else if (reportRes.Type == 'Error') {
        this.$layer.alert(reportRes.Content);
      }
    },
    // 原材料
    setRawEnterData (node) {
      for (let subnode of node.subnodelist) {
        if ("原材料储存" == subnode.nodeName) {
          this.rowPicDataArr = subnode.img
          this.rowRadioValue = subnode.nodeState
          this.rowRadioRemark = subnode.remark
        }
        if ("原材料抽检" == subnode.nodeName) {
          this.rowCheckPicDataArr = subnode.img
          this.checkInstitutionName = subnode.checkInstitutionName
          this.checkResult = subnode.checkResult
          this.rowCheckFileData.file = subnode.file
          this.rowCheckFile = subnode.file
        }
      }
    },
    scrollToCover () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.cover.offsetTop - 60
    },
    scrollToScene () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.scene.$el.offsetTop - 60
    },
    scrollToQuality () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.quality.$el.offsetTop - 60
    },
    scrollToMaterial () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.material.$el.offsetTop - 60
    },
    scrollToExtrinsic () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.extrinsic.$el.offsetTop - 60
    },
    scrollToSpot () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.spot.$el.offsetTop - 60
    },
    scrollToInfo () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.info.$el.offsetTop - 60
    },
    scrollToCommentcss () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.comment.offsetTop - 60
    },
    // like () {
    //   document.body.scrollTop = document.documentElement.scrollTop = this.$refs.spot.$el.offsetTop - 60
    // },
    scrollToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    //view
    gotoCreate () {
      this.getProQEReport()
    },
    async getProQEReport () {
      let res = await jxjGetProQEReport({
        projectId: this.id,
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      })
      if (res.Type == "Success") {
        let qeBoolean = res.Data.hasQE
        if (qeBoolean) {
          this.$router.push({ name: 'updateQEReport', params: { id: this.id, qeId: this.qeId }, query: { type: 'QE' } })
        } else {
          this.$router.push({ name: 'createQEReport', params: { id: this.id }, query: { type: 'QE' } })
        }

      } else if (res.Type == 'Error' || 'Warning' == res.Type) {
        this.$layer.alert(res.Content);
      }
    },
    async getWeather () {
      let res = await getWeather({
        city: '苏州'
      });
      if (res.Type == 'Success') {
        this.weather = res.Data;
        switch (this.weather) {
          case "晴":
            this.backgroundImage = this.sunnyImage;
            this.weatherIcon = this.sunnyIcon;
            break;
          case "高温":
            this.backgroundImage = this.hotImage;
            this.weatherIcon = this.hotIcon;
            break;
          case "雨":
            this.backgroundImage = this.rainImage;
            this.weatherIcon = this.rainIcon;
            break;
          case "雪":
            this.backgroundImage = this.snowImage;
            this.weatherIcon = this.snowIcon;
            break;
          case "雾":
            this.backgroundImage = this.fogImage;
            this.weatherIcon = this.fogIcon;
            break;
          case "阴":
            this.backgroundImage = this.cloudyImage;
            this.weatherIcon = this.cloudyIcon;
            break;
        }
      }
    },
    async jxjAddReplis (content, repId) {
      this.reParams.id = this.$route.params.qeId
      this.reParams.content = content;
      if (repId) {
        this.reParams.repId = repId;
      } else {
        this.reParams.repId = '';
      }
      let res = await jxjAddReplis(this.reParams);
      if (res.Type == 'Success') {
        this.$layer.alert(res.Content);
        this.init()
      } else {
        this.$layer.alert(res.Content);
      }
    },
    showReplayFunc (index) {
      // debugger;
      console.log("showReplayFunc", this.detail)
      this.detail.reps[index].showReplay = !this.detail.reps[index].showReplay;
    },
    closeQiandao () {
      this.qiandaoDir = false;
    },
    openQiandao () {
      this.qiandaoDir = true;
    },
  },
  created () {
    this.id = this.$route.params.id
    this.qeId = this.$route.params.qeId
    this.init()
    this.getWeather()
  }
}
</script>

